import styled from "styled-components";
import { TableWrapper } from "../../../components/Table/styled";
import { WrapperContainer } from "../../../components";

export const NotificationImageContainer = styled(WrapperContainer)`
  width: 40px;
  height: 40px;

  min-width: 40px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const NotificationsTableWrapper = styled.div`
  ${TableWrapper} {
    overflow: visible;
  }
`;
